import { Grid } from "@material-ui/core";
import { Cell, Legend, Pie, PieChart, ResponsiveContainer, Tooltip } from "recharts";
import { exceptionCountsWidgetStyle } from "./style";
import { IconTruck } from "icons";
import { groupBy } from "lodash";
import { loadStatusReasonOwner, loadStatusReasonOwnerObj } from "../loadsDashboardConsts";
import { loadStatuses } from "features/loads/enums";
import LoadsListDialog from "../LoadsListDialog";
import React, { useState } from "react";

const ExceptionPieChart = ({ loads, statuses }) => {
    const classes = exceptionCountsWidgetStyle();

    const [selectedBar, setSelectedBar] = useState(null);
    const [openDialog, setOpenDialog] = useState(false);

    const groupedExceptions = groupBy(loads, 'reasonOwner');

    let clientExceptions = groupedExceptions[loadStatusReasonOwner.CLIENT] || [];
    let tenantExceptions = groupedExceptions[loadStatusReasonOwner.TENANT] || [];
    let otherExceptions = groupedExceptions[loadStatusReasonOwner.OTHER] || [];

    const graphData = [
        {
            name: loadStatusReasonOwnerObj[loadStatusReasonOwner.CLIENT].name,
            value: clientExceptions?.length ?? 0,
            loads: clientExceptions,
            color: loadStatusReasonOwnerObj[loadStatusReasonOwner.CLIENT].color
        },
        {
            name: loadStatusReasonOwnerObj[loadStatusReasonOwner.TENANT].name,
            value: tenantExceptions.length ?? 0,
            loads: tenantExceptions,
            color: loadStatusReasonOwnerObj[loadStatusReasonOwner.TENANT].color
        },
        {
            name: loadStatusReasonOwnerObj[loadStatusReasonOwner.OTHER].name,
            value: otherExceptions?.length ?? 0,
            loads: otherExceptions,
            color: loadStatusReasonOwnerObj[loadStatusReasonOwner.OTHER].color
        },
    ];

    const CustomTooltip = ({ payload }) => {
        return (
            <div className={classes.tooltip}>
                <p>
                    <div style={{ color: payload?.[0]?.payload?.color }}><b>{payload?.[0]?.payload.name}</b></div>
                    <div style={{ fontSize: 16, fontWeight: 600 }}>{payload?.[0]?.payload?.value}</div>
                </p>
            </div>
        );
    };

    const onClickBar = (data) => {
        setSelectedBar(data);
        setOpenDialog(true);
    }

    const CustomTitle = () => {
        return <div className={classes.dialogTitleWrapper}>
            <div className={classes.dialogTitle}>
                <IconTruck />
                {statuses?.includes(loadStatuses.EXCEPTION) ? 'Exception' : 'Cancelled'} Loads ({selectedBar?.value})
            </div>
            <div className={classes.dialogSubTitle}>Reason Owner: <b style={{ color: selectedBar?.color }}>{selectedBar?.name}</b></div>
        </div>
    }

    return <Grid item style={{ height: 350, marginLeft: '1rem' }}>
        <ResponsiveContainer width="100%" height="100%">
            <PieChart>
                <Pie
                    data={graphData}
                    dataKey="value"
                    nameKey="name"
                    cx={"50%"} cy={"50%"}
                    innerRadius={65} outerRadius={80}
                    paddingAngle={0}
                    startAngle={-270} // Starting angle (90° = top of the circle)
                    endAngle={90}
                >
                    {graphData.map((entry, index) => (
                        <Cell cursor="pointer" key={`cell-${index}`} fill={entry?.color} onClick={() => onClickBar(entry)} />
                    ))}
                </Pie>
                <Legend
                    height={36}
                    iconType="circle"
                    layout="horizontal"
                    verticalAlign="bottom"
                    iconSize={8}

                    padding={5}
                    wrapperStyle={{ bottom: 0, fontSize: 11 }}
                />
                <foreignObject x="50%" y="50%" width="40" height="40" transform="translate(-10,-40)">
                    <IconTruck />
                </foreignObject>
                <text
                    x="50%"
                    y="50%"
                    textAnchor="middle"
                    dominantBaseline="middle"
                    fontSize="12"
                    fontWeight="400"
                >
                    {`${statuses?.includes(loadStatuses.EXCEPTION) ? 'Exception' : 'Cancelled'} Loads`}
                </text>
                <Tooltip content={<CustomTooltip />} />
            </PieChart>
        </ResponsiveContainer>
        <LoadsListDialog
            loads={selectedBar?.loads}
            openDialog={openDialog}
            setOpenDialog={setOpenDialog}
            title={<CustomTitle />}
        />
    </Grid>
}
export default ExceptionPieChart;